// extracted by mini-css-extract-plugin
export default {"container":"EmptyTour_container__0JidC","modalButton":"EmptyTour_modalButton__+TCXF","modalText":"EmptyTour_modalText__Bawql"};